import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { STUDIO_NAVIGATE_EVENT, type StudioNavigateEventDetail } from '../lib/embedHost';

/**
 * Listens for `studio:navigate` messages coming from the parent (via
 * `embedHost` → CustomEvent) and applies them to react-router. Used to
 * mirror the parent's back/forward button into Studio's internal routing.
 */
export const NavigationInbound = (): null => {
  const history = useHistory();

  useEffect(() => {
    const handler = (event: Event): void => {
      const detail = (event as CustomEvent<StudioNavigateEventDetail>).detail;
      if (!detail?.path) return;
      history.push(`${detail.path}${detail.search}`, detail.state);
    };
    window.addEventListener(STUDIO_NAVIGATE_EVENT, handler);
    return () => window.removeEventListener(STUDIO_NAVIGATE_EVENT, handler);
  }, [history]);

  return null;
};
